import "./index.scss";
import "./js/theme"
import {App} from "./app/app";
import {store} from "./store";
import {router} from "./router";
import {ApiPlugin} from "./plugins/api/api";
import {createApp} from "vue";
import {WPPlugin} from "./plugins/wp/wp";

const app = createApp({
	template: "<App></App>",
	components: {
		App,
	},
});

app.use(ApiPlugin, {});
app.use(router);
app.use(store);
app.use(WPPlugin);

app.mount("#vue-app");
